const rootPath = "alerts"

export const ALERTS_PATHS = {
  root: rootPath,
  cookingDelays: "cooking-delays",
  conditioningDelays: "conditioning-delays",
  reproductionNeeds: "reproduction-needs",
  qhseConformity: "qhse-conformity",
}
